import {Component, OnDestroy, OnInit} from '@angular/core';
import {SitesService} from '../../services/sites.service';
import {DataService} from '../../services/data.service';
import {ServersService} from '../../services/servers.service';
import {Router} from '@angular/router';
import {SiteModel} from '../../models/site.model';
import {Subscription} from 'rxjs/Subscription';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MasterService} from '../../services/master.service';
import {combineLatest} from 'rxjs';
import {ServerModel} from '../../models/server.model';

@Component({
  selector: 'lba-select-site',
  templateUrl: './select-site.component.html',
  styleUrls: ['./select-site.component.scss'],
})
export class SelectSiteComponent implements OnInit, OnDestroy {

  searchStr: string = '';

  sites: SiteModel[];

  siteName: string = 'Select site';

  subscription: Subscription;

  isLoaded: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private siteService: SitesService,
    private dataService: DataService,
    private serverService: ServersService,
  ) {}

  ngOnInit() {

    console.log(this.dataService.selectedUser);

    this.subscription = combineLatest(
      this.siteService.getSites(),
      this.serverService.getServers(),
    ).subscribe((data: [SiteModel[], ServerModel[]]) => {
        const filteredSites = data[0].filter(
          site => {
            const server = this.serverService.getServerFromId(site.serverId, data[1]);
            if (server) {
              site.domainName = server.domain;
              site.serverName = server.name;
              site.serverId = server.id;
              if (site.serverName === 'Archive') {
                return false;
              }
            }

            if (this.dataService.sitesToExclude) {
              for (const excludingSite of this.dataService.sitesToExclude) {
                // console.log('excluding site: ', excludingSite);
                if (excludingSite.id === site.id) {
                  return false;
                }
              }
            } else {
              // console.log('no sites to exclude');
            }
            return true;
          });
        this.dataService.sitesToExclude = null;
        this.isLoaded = true;


        if (this.dataService.serverToFilter != null) {
          this.sites = filteredSites.filter(
            site => site.serverId === this.dataService.serverToFilter);
        } else {
          this.sites = filteredSites;
        }

        if (this.dataService.selectedUser.userType === 'distributors') {
          this.sites = filteredSites.filter(site => site.serverId === this.dataService.selectedUser.serverId)
        }
        // console.log('select site list:', this.sites)
      },
      error => {
        console.log(error);
        window.alert('Error: ' + error.message + ', error status: ' + error.status);
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  selectSite(selectedSite: SiteModel) {
    this.activeModal.close(selectedSite);
  }

}
